import mypic from "../../assets/aboutImage.JPG";
import SideMenuWrapper from "./SideMenuWrapper";
const SideMenu = () => {
  return (
    <SideMenuWrapper>
      <img src={mypic} alt="" />
      <div className="side-menu__text">
        <h3>{"<Abhishek Rajput />"}</h3>
        <div>
          <h4>Software/web Developer</h4>
        </div>
        <p>
          Every project is a chance to learn something new and build something
          better.
        </p>
      </div>
    </SideMenuWrapper>
  );
};
export default SideMenu;
